<div>
  <h1 mat-dialog-title>{{ data.title }}</h1>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content class="mat-dialog-content">
  <mat-label>File type</mat-label>
  <mat-form-field appearance="outline" class="mat-form-field">
    <mat-select
      placeholder="Select type"
      name="fileType"
      [(ngModel)]="selectedOption"
      (selectionChange)="onFileTypeChange()"
    >
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="file-upload">
    <input
      type="file"
      class="file-input"
      (change)="handleFileInput($event)"
      [accept]="getAcceptType(selectedOption)"
      #fileUpload
      multiple
    />
    <button
      mat-stroked-button
      type="button"
      [disabled]="!isFileUploadEnabled || addedFiles.length >= 1"
      (click)="fileUpload.click()"
    >
      <span>Select file</span>
    </button>
  </div>
</div>

<div class="file-list">
  <mat-list>
    <mat-list-item *ngFor="let file of addedFiles; let i = index">
      <div class="file-list-item-row">
        <div class="file-list-item-title" matTooltip="{{ file.name }}">
          <span class="file-name">{{ file.name }}</span>
        </div>
        <button
          mat-icon-button
          type="button"
          matTooltip="Remove file"
          (click)="removeFile(file, i)"
        >
          <mat-icon>delete_forever</mat-icon>
        </button>
      </div>
    </mat-list-item>
  </mat-list>
</div>

<mat-dialog-actions align="end">
  <button
    mat-button
    class="upload-button"
    (click)="onUploadFile()"
    [disabled]="isUploadDisabled"
    [ngClass]="{ 'upload-button-disabled': isUploadDisabled }"
  >
    Upload
  </button>
  <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
</mat-dialog-actions>

<div *ngIf="isLoading" class="spinner">
  <div class="spinner__background"></div>
  <div class="spinner__plane" [ngClass]="['spinner__plane--' + 'md']"></div>
  <div class="spinner__swipe"></div>
</div>
